module.exports = __webpack_public_path__ + "img/logo_dike.5aae0701.png";